import React from 'react'
import PropTypes from 'prop-types'
import {
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {SensitiveIcon, SensitiveOffIcon} from '../../icons'

// A password field whose eye actually reveals the password. The screens used to
// draw the icon as an ornament next to a field fixed at type="password", which
// read as a control and did nothing.
const PasswordInput = ({...inputProps}) => {
  const {t} = useTranslation('common')
  const [revealed, setRevealed] = React.useState(false)

  return (
    <InputGroup size="lg">
      <InputRightElement>
        <IconButton
          variant="ghost"
          size="sm"
          color="mld.neutral.0"
          aria-label={t(
            revealed ? 'common:hidePassword' : 'common:showPassword',
          )}
          icon={revealed ? <SensitiveOffIcon /> : <SensitiveIcon />}
          onClick={() => setRevealed((shown) => !shown)}
        />
      </InputRightElement>
      <Input
        type={revealed ? 'text' : 'password'}
        size="lg"
        fontSize="base"
        {...inputProps}
      />
    </InputGroup>
  )
}

PasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}

export default PasswordInput
